import React, { useState } from "react";
import CurrentTimer from "../CurrentTimer";
import Countdown from "../Countdown";
import { ChevronLeft, ChevronRight } from "lucide-react";

const ExamNavigation = ({
  currentMQ,
  questionsMQ,
  current,
  isDisabledBack,
  isDisabledNext,
  handleNav,
  examData,
  assessmentId,
  handleSubmit,
  handleTimeUp,
  setShowInfoPanel,
  showInfoPanel,
  isCurrentQuestionMQ,
}) => {
  // Handle navigation without loading effect
  const handleNavWithLoading = (currentIndex, isNext) => {
    handleNav(currentIndex, isNext);
  };

  // Sử dụng helper function để check MQ
  const isMQQuestion = isCurrentQuestionMQ();

  if (!isMQQuestion) {
    return (
      <div className="mt-5 bg-white rounded-lg shadow-md px-4 py-3">
        {/* Mobile Layout */}
        <div className="block md:hidden w-full">
          {/* Single row: Navigation buttons, Timer, Menu button */}
          <div className="flex items-center justify-between gap-2">
            {/* Left: Navigation buttons */}
            <div className="flex items-center gap-1 flex-shrink-0">
              <button
                className={`flex items-center justify-center p-2 text-sm ${
                  isDisabledBack
                    ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                    : "bg-gray-200 hover:bg-[#1c3664] text-black hover:text-white hover:opacity-90"
                } rounded-md font-medium transition-colors w-8 h-8`}
                disabled={isDisabledBack}
                onClick={() => handleNavWithLoading(current, false)}
              >
                <ChevronLeft size={14} />
              </button>

              <button
                className={`flex items-center gap-1 px-2 py-2 text-xs ${
                  isDisabledNext
                    ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                    : "bg-[#1c3664] text-white hover:opacity-90"
                } rounded-md font-medium transition-colors flex-shrink-0`}
                disabled={isDisabledNext}
                onClick={() => handleNavWithLoading(current, true)}
              >
                <span>Câu tiếp</span>
                <ChevronRight size={12} />
              </button>
            </div>

            {/* Center: Countdown timer only */}
            {/* <div className="flex items-center justify-center text-center flex-1 min-w-0">
              <div className="text-lg font-mono font-bold text-[#cd1627]">
                <Countdown
                  exam={examData}
                  onComplete={handleTimeUp}
                  assessmentId={assessmentId}
                  isTitle={false}
                />
              </div>
            </div> */}

            {/* Right: Menu button */}
            <button
              className="flex items-center gap-1 px-2 py-2 text-xs bg-[#cd1627] text-white hover:opacity-90 rounded-lg font-semibold transition-all flex-shrink-0 max-w-[120px]"
              onClick={() => setShowInfoPanel(!showInfoPanel)}
            >
              <span className="truncate">‹ Menu / Nộp bài</span>
            </button>
          </div>
        </div>

        {/* Desktop Layout - chỉ navigation và time, không có menu button */}
        <div className="hidden lg:flex items-center gap-4">
          {/* Left: Navigation buttons */}
          <div className="flex items-center gap-2">
            <button
              className={`flex items-center gap-2 px-4 py-3 ${
                isDisabledBack
                  ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                  : "bg-gray-200 hover:bg-[#1c3664] focus:ring-[#1c3664] text-black hover:text-white hover:opacity-90 rounded-lg font-semibold transition-all duration-300 shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2"
              } rounded-md font-medium transition-colors`}
              disabled={isDisabledBack}
              onClick={() => handleNavWithLoading(current, false)}
            >
              <ChevronLeft />
            </button>

            <button
              className={`flex items-center gap-2 px-4 py-3 min-w-[125px] ${
                isDisabledNext
                  ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                  : "bg-[#1c3664] hover:bg-[#1c3664] focus:ring-[#1c3664] text-white hover:opacity-90 rounded-lg font-semibold transition-all duration-300 shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2"
              } rounded-md font-medium transition-colors`}
              disabled={isDisabledNext}
              onClick={() => handleNavWithLoading(current, true)}
            >
              <span>Câu tiếp</span>
              <ChevronRight />
            </button>
          </div>

          {/* Time display */}
          <div className="flex items-center text-center">
            {/* <div className="text-base text-black mr-[1rem] sm:mr-[4rem]">
              Thời gian làm câu hiện tại
            </div> */}
            {/* <CurrentTimer
              exam={examData}
              current={current}
              assessmentId={assessmentId}
            /> */}
          </div>
        </div>

        {/* Medium screens (md to lg) - có menu button */}
        <div className="hidden md:flex lg:hidden items-center justify-between w-full">
          {/* Left: Navigation buttons and time */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <button
                className={`flex items-center gap-2 px-4 py-3 ${
                  isDisabledBack
                    ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                    : "bg-gray-200 hover:bg-[#1c3664] focus:ring-[#1c3664] text-black hover:text-white hover:opacity-90 rounded-lg font-semibold transition-all duration-300 shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2"
                } rounded-md font-medium transition-colors`}
                disabled={isDisabledBack}
                onClick={() => handleNavWithLoading(current, false)}
              >
                <ChevronLeft />
              </button>

              <button
                className={`flex items-center gap-2 px-4 py-3 min-w-[125px] ${
                  isDisabledNext
                    ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                    : "bg-[#1c3664] hover:bg-[#1c3664] focus:ring-[#1c3664] text-white hover:opacity-90 rounded-lg font-semibold transition-all duration-300 shadow-sm hover:shadow-md focus:outline-none focus:ring-2 focus:ring-offset-2"
                } rounded-md font-medium transition-colors`}
                disabled={isDisabledNext}
                onClick={() => handleNavWithLoading(current, true)}
              >
                <span>Câu tiếp</span>
                <ChevronRight />
              </button>
            </div>

            {/* Time display */}
            <div className="flex items-center text-center">
              {/* <div className="text-base text-black mr-[1rem] sm:mr-[4rem]">
                Thời gian làm câu hiện tại
              </div> */}
              {/* <CurrentTimer
                exam={examData}
                current={current}
                assessmentId={assessmentId}
              /> */}
            </div>
          </div>

          {/* Right: Menu button */}
          <div className="flex items-center">
            <button
              className="flex items-center gap-2 px-4 py-3 bg-[#cd1627] hover:opacity-90 text-white rounded-lg font-semibold transition-all shadow-sm"
              onClick={() => setShowInfoPanel(!showInfoPanel)}
            >
              <span>‹ Mở menu / Nộp bài</span>
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="mt-5 bg-white rounded-lg shadow-md px-2 py-2 w-full max-w-full overflow-hidden">
      {/* Mobile Layout (smaller screens) */}
      <div className="block md:hidden w-full">
        {/* Single row: Navigation buttons, Timer, Menu button */}
        <div className="flex items-center justify-between w-full min-w-0 gap-2">
          {/* Left: Navigation buttons */}
          <div className="flex items-center gap-1 flex-shrink-0">
            <button
              className={`flex items-center justify-center p-2 text-sm ${
                isDisabledBack
                  ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                  : "bg-gray-200 hover:bg-[#1c3664] text-black hover:text-white hover:opacity-90"
              } rounded-md font-medium transition-colors w-8 h-8`}
              disabled={isDisabledBack}
              onClick={() => handleNavWithLoading(current, false)}
            >
              <ChevronLeft size={14} />
            </button>

            <button
              className={`flex items-center gap-1 px-2 py-2 text-xs ${
                isDisabledNext
                  ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                  : "bg-[#1c3664] text-white hover:opacity-90"
              } rounded-md font-medium transition-colors flex-shrink-0`}
              disabled={isDisabledNext}
              onClick={() => handleNavWithLoading(current, true)}
            >
              <span>Câu tiếp</span>
              <ChevronRight size={12} />
            </button>
          </div>

          {/* Center: Countdown timer only */}
          {/* <div className="flex items-center justify-center text-center flex-1 min-w-0">
            <div className="text-lg font-mono font-bold text-[#cd1627]">
              <Countdown
                exam={examData}
                onComplete={handleTimeUp}
                assessmentId={assessmentId}
                isTitle={false}
              />
            </div>
          </div> */}

          {/* Right: Menu button */}
          <button
            className="flex items-center gap-1 px-2 py-2 text-xs bg-[#cd1627] text-white hover:opacity-90 rounded-lg font-semibold transition-all flex-shrink-0 max-w-[120px]"
            onClick={() => setShowInfoPanel(!showInfoPanel)}
          >
            <span className="truncate">‹ Menu / Nộp bài</span>
          </button>
        </div>
      </div>

      {/* Desktop Layout (larger screens) */}
      <div className="hidden md:flex items-center justify-between w-full">
        {/* Left: Navigation buttons and current time */}
        <div className="flex items-center gap-4">
          <div className="flex items-center gap-2">
            <button
              className={`flex items-center gap-2 px-4 py-3 ${
                isDisabledBack
                  ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                  : "bg-gray-200 hover:bg-[#1c3664] text-black hover:text-white hover:opacity-90 "
              } rounded-lg font-semibold transition-all shadow-sm`}
              disabled={isDisabledBack}
              onClick={() => handleNavWithLoading(current, false)}
            >
              <ChevronLeft />
            </button>

            <button
              className={`flex items-center gap-2 px-4 py-3 ${
                isDisabledNext
                  ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                  : "bg-[#1c3664] hover:opacity-90 text-white"
              } rounded-lg font-semibold transition-all shadow-sm`}
              disabled={isDisabledNext}
              onClick={() => handleNavWithLoading(current, true)}
            >
              <span>Câu tiếp</span>
              <ChevronRight />
            </button>
          </div>

          {/* Current question time */}
          <div className="flex items-center text-center">
            {/* <div className="text-base text-black mr-4">
              Thời gian làm câu hiện tại
            </div> */}

            {/* <CurrentTimer
              exam={examData}
              current={current}
              assessmentId={assessmentId}
            /> */}
          </div>
        </div>

        {/* Right: Time left and Menu button */}
        <div className="flex items-center gap-4">
          {/* <div className="flex flex-col items-center justify-center">
            <Countdown
              exam={examData}
              onComplete={handleTimeUp}
              assessmentId={assessmentId}
            />
          </div> */}

          <button
            className="flex items-center gap-2 px-4 py-3 bg-[#cd1627] hover:opacity-90 text-white rounded-lg font-semibold transition-all shadow-sm"
            onClick={() => setShowInfoPanel(!showInfoPanel)}
          >
            <span>‹ Mở menu / Nộp bài</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ExamNavigation;
